import React from 'react';

import {useI18n} from '@udemy/i18n';
import {CourseDirectoryWrapper} from '@udemy/react-discovery-units';

import styles from './course-list.module.less';

export const CourseList: React.FC<{
    hasOrganization: boolean;
    isPersonalPlanSubscriber: boolean;
}> = ({hasOrganization, isPersonalPlanSubscriber}) => {
    const {gettext} = useI18n();

    return (
        <>
            <div className={styles['course-list-header']}>
                <h2 className={'ud-heading-xl'}>{gettext('All courses with Role Play')}</h2>
                <p className={'ud-text'}>
                    {gettext(
                        'Explore courses with Role Play to build your communication and soft skills',
                    )}
                </p>
            </div>

            <div className={styles['course-directory-wrapper']}>
                <CourseDirectoryWrapper
                    controlledProps={{
                        // Do not render popover on server
                        usePopover: typeof window !== 'undefined',
                        fullQuickView: !hasOrganization && !isPersonalPlanSubscriber,
                    }}
                />
            </div>
        </>
    );
};
